import { normalizeText } from './utils.js';

/* «Tendencias»: cruza la lista de tendencias de TMDB con el catálogo del proveedor para enseñar
   solo los títulos que de verdad se pueden ver. Módulo puro, sin DOM ni estado. */

// Mismas etiquetas que limpia el servidor antes de buscar en TMDB (server/tmdb.js).
const NOISE = /\b(4K|UHD|FHD|HD|SD|HDR|HDR10|DV|1080p|720p|2160p|x265|x264|HEVC|H\.?264|H\.?265|DUAL|LAT|LATINO|ESP|CAST|CASTELLANO|SUB|VOSE|VOS|MULTI|WEB-?DL|BLURAY|BDRIP|DVDRIP|CAM|TS)\b/gi;

/** "ES - Jurassic World: El renacer (2025) [4K]" → "jurassic world el renacer" */
export function titleKey(name) {
    return normalizeText(String(name || '')
        .replace(/\[[^\]]*\]|\([^)]*\)|\{[^}]*\}/g, ' ')
        .replace(/^\s*[A-Z]{2,3}\s*[-|:]\s+/, '')
        .replace(NOISE, ' '));
}

/** Índice del catálogo por id de TMDB y por título, para no recorrerlo con cada tendencia. */
export function buildIndex(items) {
    const byTmdb = new Map();
    const byTitle = new Map();
    items.forEach((item) => {
        if (item.tmdb && !byTmdb.has(String(item.tmdb))) byTmdb.set(String(item.tmdb), item);
        const key = titleKey(item.name);
        if (!key) return;
        const list = byTitle.get(key);
        if (list) list.push(item); else byTitle.set(key, [item]);
    });
    return { byTmdb, byTitle };
}

function byTitleAndYear(index, title, year) {
    const list = index.byTitle.get(titleKey(title));
    if (!list) return null;
    const y = Number(year) || 0;
    // Mismo título y otro año es otra película (un remake): con año en los dos lados, ±1.
    const ok = list.filter((it) => !y || !Number(it.year) || Math.abs(Number(it.year) - y) <= 1);
    if (!ok.length) return null;
    return ok.find((it) => Number(it.year) === y) || ok[0];
}

/**
 * trending: [{ tmdbId, kind, title, originalTitle, year }] en orden de tendencia.
 * catalog:  { vod: [...], series: [...] } con lo que el espectador puede ver.
 * Devuelve [{ kind, item, rank }] sin repetir títulos (un proveedor suele tener la misma
 * película en varias calidades).
 */
export function matchTrending(trending, catalog, { limit = 20 } = {}) {
    if (!trending || !trending.length) return [];
    const index = { vod: buildIndex(catalog.vod || []), series: buildIndex(catalog.series || []) };
    const out = [];
    const used = new Set();
    for (let i = 0; i < trending.length && out.length < limit; i++) {
        const tr = trending[i];
        const idx = index[tr.kind];
        if (!idx) continue;
        const item = idx.byTmdb.get(String(tr.tmdbId))
            || byTitleAndYear(idx, tr.title, tr.year)
            || (tr.originalTitle && tr.originalTitle !== tr.title ? byTitleAndYear(idx, tr.originalTitle, tr.year) : null);
        if (!item || used.has(tr.kind + ':' + item.id)) continue;
        used.add(tr.kind + ':' + item.id);
        out.push({ kind: tr.kind, item, rank: i + 1 });
    }
    return out;
}
